import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const redmineCustomDropDownMap = ['Type', 'Sub Type', 'Resolution Type'].reduce((dropDownMap, name) => {
  dropDownMap[name] = {
    field: -1,
    list: [],
    defaultValue: null
  }
  return dropDownMap
}, {})

const redmineCustomTextFieldMap = ['Batch ID', 'Ref No', 'Ref Type', 'Detail', 'Assign To', 'Vendor Name', 'Vendor Name2', 'Vendor Code', 'Resolution', 'Status Note', 'Assigned Date', 'Resolved Date', 'Anticipated Ship cancel date', 'INDC Date', 'COO', 'Attachment Info', 'Brand'].reduce((textFieldMap, name) => {
  textFieldMap[name] = {
    field: -1,
    defaultValue: null
  }
  return textFieldMap
}, {})

const redmineBuiltInFieldMap = ['project', 'tracker', 'status', 'subject', 'priority'].reduce((fieldMap, name) => {
  fieldMap[name] = {
    field: name + '_id',
    defaultValue: null
  }
  return fieldMap
}, {})
// redmineBuiltInFieldMap.tracker.defaultValue = 2 // 'Feature' in Redmine
redmineBuiltInFieldMap.subject.field = 'subject'
redmineBuiltInFieldMap.tracker.list = []
redmineBuiltInFieldMap.status.list = []
redmineBuiltInFieldMap.priority.list = []
// redmineBuiltInFieldMap.priority.defaultValue = 2 // 'Normal' in Redmine

const state = {
  dropDownValuesRetrieved: false,
  ...redmineCustomDropDownMap,
  ...redmineCustomTextFieldMap,
  ...redmineBuiltInFieldMap,
  teamMembers: [],
  searchResultList: [],
  searchResultListSelected: [],
  vendorNameToIdMap: {},
  vendorIdToNameMap: {},
  teamLeaderEmailMap: [],
  sharepointFolderId: null,
  workflow: null,
  workflowPermission: null,
  searchCriteria: null,
  redmineRoleId: null,
  customFieldVisibilities: {},
  vendorList: []
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/sourcing_workflow/service_request/store/index.js